//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ContactUsCard',
  props: {
    title: {
      type: String,
      default: 'do-you-still-have-questio'
    },
    text: {
      type: String,
      default: 'contact-us-we-re-online-'
    }
  }
}
